module.exports = __webpack_public_path__ + "static/media/fa-regular-400.dddf7b2c.ttf";